<mh-core-lib-loader-wrapper [loading]="loading" [type]="'spinner'" class="tw-h-full tw-flex tw-flex-col tw-min-h-[8rem]" className="tw-text-3xl">
    @if (!error) {
        <div class="tw-flex tw-flex-col tw-h-full tw-justify-between">
            <div>
                <div class="tw-flex tw-items-center">
                    <span class="tw-font-medium tw-text-base">{{ title }}</span>
                    <span class="tw-ml-1 tw-text-gray-400 tw-text-base tw-font-medium">{{ subtitle }}</span>
                </div>
                <p class="tw-text-sm tw-italic">
                    @if (enabled) {
                        {{ value ? description : ('qualifys.nps.no_data' | translate) }}
                    } @else {
                        {{ 'interchain-dashboard.widget_disabled.' + product | translate }}
                    }
                </p>
            </div>
            <div>
                @if (enabled) {
                    <div class="tw-flex tw-items-center">
                        <span class="tw-text-4xl tw-font-bold">{{ value || '-' }}</span>
                        @if (showChart) {
                            <div class="tw-h-10 tw-flex-1 tw-ml-4 tw-w-full tw-overflow-hidden tw-max-w-[70%]">
                                <canvas baseChart
                                    class="tw-w-full tw-h-full"
                                    [data]="chartData"
                                    [options]="chartOptions"
                                    [type]="'line'"
                                    [plugins]="chartPlugins">
                                </canvas>
                            </div>
                        }
                    </div>
                }
            </div>
            <div class="tw-flex tw-items-center">
                @if (enabled && showChange) { 
                    <span
                        [class]="(changePercentage === null || changePercentage === 0) ? 'tw-text-gray-400' : (increase ? 'tw-text-green-500' : 'tw-text-red-400')"
                        class="tw-flex tw-items-center"
                        [mhTooltip]="changePercentage === null ? ('interchain-dashboard.qualification-texts.no-data' | translate) : (changePercentage === 0 ? ('commons.not_variation' | translate) : ('interchain-dashboard.qualification-texts.variation' | translate))"
                        width="fit-content">
                        @if (changePercentage !== null && changePercentage !== 0) {
                            <i class="fas fa-arrow-up tw-text-sm"
                               [class.tw-rotate-45]="increase"
                               [class.tw-rotate-[135deg]]="!increase"></i>
                        }
                        <span class="tw-text-sm tw-font-bold tw-ml-1">
                            {{ changePercentage === null ? '-' : (changePercentage === 0 ? '0%' : (changePercentage + (percentage ? '%' : ''))) }}
                        </span>
                    </span>
                }
                <div class="tw-flex-1"></div>
                @if (product !== 'semantic' || route) {
                    @if (enabled) {
                        <button class="tw-text-main-blue tw-text-base tw-font-semibold tw-uppercase focus:!tw-outline-none" (click)="goToLink()">{{ 'commons.see_more' | translate }}</button>
                    } @else {
                        <button class="tw-text-main-blue tw-text-base tw-font-semibold tw-uppercase focus:!tw-outline-none" (click)="seeDemo(product)">{{ (demoRoute ? 'commons.learn_more' : 'interchain-dashboard.see_demo') | translate }}</button>
                    }
                }
            </div>
        </div>
    } @else {
        <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-full">
            <h2 class="tw-text-2xl tw-font-bold tw-text-main-text">{{ 'commons.error' | translate }}</h2>
            <p class="tw-text-main-text tw-text-center">{{ 'interchain-dashboard.widget_error' | translate }}</p>
        </div>
    }
</mh-core-lib-loader-wrapper>
